import script from "./tag.vue?vue&type=script&setup=true&lang=js"
export * from "./tag.vue?vue&type=script&setup=true&lang=js"

import "./tag.vue?vue&type=style&index=0&id=5046cf75&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5046cf75"]])

export default __exports__